module.exports = __webpack_public_path__ + "img/Reports.2116676b.svg";